import { actionAreaContainer, container, footerToolbar, inputDisabled, invalidPrimaryKeyContainer, invalidPrimaryKeyIconContainer, invalidPrimaryKeyContentWrapper, invalidPrimaryKeyMessage, invalidPrimaryKeyTitle, loadingContainer, upperToolbar, outlier, outlierContent, outlierDetected, outlierDetectedText, pagerControl, pagerControlDisabled, pagerLink, pagerLinkDisabled, pagerList, pagerItem, pagerItemActive, pagerItemDisabled, pagerRangeContainer, pagerRangeContainerDisabled, selectedCountContainer, selectedCountContainerDisabled, sortWrapperAsc, sortWrapperAscDisabled, sortWrapperDesc, sortWrapperDescDisabled, table, td, tdToggleExpanded, tdToggleNotExpanded, tdToggleDisabled, th, thDisabled, thGroup, thGroups, thSortable, tr, trAlt, trAltDisabled, trDisabled, trError, trWarning, warningMessage, } from '../styles/legacy';
import { actionAreaContainer as actionAreaContainerCitron, container as containerCitron, footerToolbar as footerToolbarCitron, inputDisabled as inputDisabledCitron, invalidPrimaryKeyContainer as invalidPrimaryKeyContainerCitron, invalidPrimaryKeyIconContainer as invalidPrimaryKeyIconContainerCitron, invalidPrimaryKeyContentWrapper as invalidPrimaryKeyContentWrapperCitron, invalidPrimaryKeyMessage as invalidPrimaryKeyMessageCitron, invalidPrimaryKeyTitle as invalidPrimaryKeyTitleCitron, loadingContainer as loadingContainerCitron, upperToolbar as upperToolbarCitron, outlier as outlierCitron, outlierContent as outlierContentCitron, outlierDetected as outlierDetectedCitron, outlierDetectedText as outlierDetectedTextCitron, pagerControl as pagerControlCitron, pagerControlDisabled as pagerControlDisabledCitron, pagerLink as pagerLinkCitron, pagerLinkDisabled as pagerLinkDisabledCitron, pagerList as pagerListCitron, pagerItem as pagerItemCitron, pagerItemActive as pagerItemActiveCitron, pagerItemDisabled as pagerItemDisabledCitron, pagerRangeContainer as pagerRangeContainerCitron, pagerRangeContainerDisabled as pagerRangeContainerDisabledCitron, selectedCountContainer as selectedCountContainerCitron, selectedCountContainerDisabled as selectedCountContainerDisabledCitron, sortWrapperAsc as sortWrapperAscCitron, sortWrapperAscDisabled as sortWrapperAscDisabledCitron, sortWrapperDesc as sortWrapperDescCitron, sortWrapperDescDisabled as sortWrapperDescDisabledCitron, table as tableCitron, td as tdCitron, tdToggleExpanded as tdToggleExpandedCitron, tdToggleNotExpanded as tdToggleNotExpandedCitron, tdToggleDisabled as tdToggleDisabledCitron, th as thCitron, thDisabled as thDisabledCitron, thGroup as thGroupCitron, thGroups as thGroupsCitron, thSortable as thSortableCitron, tr as trCitron, trAlt as trAltCitron, trAltDisabled as trAltDisabledCitron, trAltError as trAltErrorCitron, trAltWarning as trAltWarningCitron, trDisabled as trDisabledCitron, trError as trErrorCitron, trWarning as trWarningCitron, warningMessage as warningMessageCitron, } from '../styles/citron';
import { citrusStyled } from '@citrus/runtime';
export var Container = citrusStyled.div('container', { legacy: container, citrus2022: containerCitron });
export var Table = citrusStyled.table('table', { legacy: table, citrus2022: tableCitron });
export var Input = citrusStyled.input('N/A', null);
export var InputDisabled = citrusStyled.input('inputDisabled', {
    legacy: inputDisabled,
    citrus2022: inputDisabledCitron,
});
export var SortWrapper = citrusStyled.span('N/A', null);
export var SortWrapperAsc = citrusStyled.span('sortWrapperAsc', {
    legacy: sortWrapperAsc,
    citrus2022: sortWrapperAscCitron,
});
export var SortWrapperAscDisabled = citrusStyled.span('sortWrapperAscDisabled', {
    legacy: sortWrapperAscDisabled,
    citrus2022: sortWrapperAscDisabledCitron,
});
export var SortWrapperDesc = citrusStyled.span('sortWrapperDesc', {
    legacy: sortWrapperDesc,
    citrus2022: sortWrapperDescCitron,
});
export var SortWrapperDescDisabled = citrusStyled.span('sortWrapperDescDisabled', {
    legacy: sortWrapperDescDisabled,
    citrus2022: sortWrapperDescDisabledCitron,
});
export var Tbody = citrusStyled.tbody('N/A', null);
export var Thead = citrusStyled.thead('N/A', null);
export var Th = citrusStyled.th('Th', { legacy: th, citrus2022: thCitron });
export var ThDisabled = citrusStyled.th('thDisabled', { legacy: thDisabled, citrus2022: thDisabledCitron });
export var ThGroup = citrusStyled.th('thGroup', { legacy: thGroup, citrus2022: thGroupCitron });
export var ThGroups = citrusStyled.tr('thGroups', { legacy: thGroups, citrus2022: thGroupsCitron });
export var ThSortable = citrusStyled.th('thSortable', { legacy: thSortable, citrus2022: thSortableCitron });
export var Tr = citrusStyled.tr('tr', { legacy: tr, citrus2022: trCitron });
export var TrAlt = citrusStyled.tr('trAlt', { legacy: trAlt, citrus2022: trAltCitron });
export var TrAltDisabled = citrusStyled.tr('trAltDisabled', {
    legacy: trAltDisabled,
    citrus2022: trAltDisabledCitron,
});
export var TrAltError = citrusStyled.tr('trAltError', { legacy: trError, citrus2022: trAltErrorCitron });
export var TrAltWarning = citrusStyled.tr('trAltWarning', { legacy: trWarning, citrus2022: trAltWarningCitron });
export var TrDisabled = citrusStyled.tr('trDisabled', { legacy: trDisabled, citrus2022: trDisabledCitron });
export var TrError = citrusStyled.tr('trError', { legacy: trError, citrus2022: trErrorCitron });
export var TrWarning = citrusStyled.tr('trWarning', { legacy: trWarning, citrus2022: trWarningCitron });
export var RowExpandable = citrusStyled.tbody('N/A', null);
export var Td = citrusStyled.td('Td', { legacy: td, citrus2022: tdCitron });
export var TdToggleExpanded = citrusStyled.td('tdToggleExpanded', {
    legacy: tdToggleExpanded,
    citrus2022: tdToggleExpandedCitron,
});
export var TdToggleNotExpanded = citrusStyled.td('tdToggleNotExpanded', {
    legacy: tdToggleNotExpanded,
    citrus2022: tdToggleNotExpandedCitron,
});
export var TdToggleDisabled = citrusStyled.td('tdToggleDisabled', {
    legacy: tdToggleDisabled,
    citrus2022: tdToggleDisabledCitron,
});
export var WarningMessage = citrusStyled.span('warningMessage', {
    legacy: warningMessage,
    citrus2022: warningMessageCitron,
});
export var ActionAreaContainer = citrusStyled.div('actionAreaContainer', {
    legacy: actionAreaContainer,
    citrus2022: actionAreaContainerCitron,
});
export var ActionAreaHeader = citrusStyled.div('N/A', null);
export var ActionAreaFooter = citrusStyled.div('N/A', null);
export var SelectedCountContainer = citrusStyled.div('selectedCountContainer', {
    legacy: selectedCountContainer,
    citrus2022: selectedCountContainerCitron,
});
export var SelectedCountContainerDisabled = citrusStyled.div('selectedCountContainerDisabled', {
    legacy: selectedCountContainerDisabled,
    citrus2022: selectedCountContainerDisabledCitron,
});
export var UpperToolbar = citrusStyled.div('upperToolbar', {
    legacy: upperToolbar,
    citrus2022: upperToolbarCitron,
});
export var FooterToolbar = citrusStyled.div('footerToolbar', {
    legacy: footerToolbar,
    citrus2022: footerToolbarCitron,
});
export var LoadingContainer = citrusStyled.div('loadingContainer', {
    legacy: loadingContainer,
    citrus2022: loadingContainerCitron,
});
export var Outlier = citrusStyled.div('outlierYellow', {
    legacy: outlier('yellow'),
    citrus2022: outlierCitron('yellow'),
});
export var OutlierGreen = citrusStyled.div('outlierGreen', {
    legacy: outlier('green'),
    citrus2022: outlierCitron('green'),
});
export var OutlierPurple = citrusStyled.div('outlierPurple', {
    legacy: outlier('purple'),
    citrus2022: outlierCitron('purple'),
});
export var OutlierRed = citrusStyled.div('outlierRed', {
    legacy: outlier('red'),
    citrus2022: outlierCitron('red'),
});
export var OutlierContent = citrusStyled.div('outlierContent', {
    legacy: outlierContent,
    citrus2022: outlierContentCitron,
});
export var OutlierDetected = citrusStyled.div('outlierDetectedYellow', {
    legacy: outlierDetected('yellow'),
    citrus2022: outlierDetectedCitron('yellow'),
});
export var OutlierDetectedGreen = citrusStyled.div('outlierDetectedGreen', {
    legacy: outlierDetected('green'),
    citrus2022: outlierDetectedCitron('green'),
});
export var OutlierDetectedPurple = citrusStyled.div('outlierDetectedPurple', {
    legacy: outlierDetected('purple'),
    citrus2022: outlierDetectedCitron('purple'),
});
export var OutlierDetectedRed = citrusStyled.div('outlierDetectedRed', {
    legacy: outlierDetected('red'),
    citrus2022: outlierDetectedCitron('red'),
});
export var OutlierDetectedText = citrusStyled.div('outlierDetectedText', {
    legacy: outlierDetectedText,
    citrus2022: outlierDetectedTextCitron,
});
// Pager
export var Pager = citrusStyled.div('N/A', null);
export var PagerContainer = citrusStyled.div('N/A', null);
export var PagerControl = citrusStyled.button('pagerControl', {
    legacy: pagerControl,
    citrus2022: pagerControlCitron,
});
export var PagerControlDisabled = citrusStyled.button('pagerControlDisabled', {
    legacy: pagerControlDisabled,
    citrus2022: pagerControlDisabledCitron,
});
export var PagerLink = citrusStyled.button('pagerLink', { legacy: pagerLink, citrus2022: pagerLinkCitron });
export var PagerLinkDisabled = citrusStyled.button('pagerLinkDisabled', {
    legacy: pagerLinkDisabled,
    citrus2022: pagerLinkDisabledCitron,
});
export var PagerList = citrusStyled.ul('pagerList', { legacy: pagerList, citrus2022: pagerListCitron });
export var PagerItem = citrusStyled.li('pagerItem', { legacy: pagerItem, citrus2022: pagerItemCitron });
export var PagerItemActive = citrusStyled.li('pagerItemActive', {
    legacy: pagerItemActive,
    citrus2022: pagerItemActiveCitron,
});
export var PagerItemDisabled = citrusStyled.li('pagerItemDisabled', {
    legacy: pagerItemDisabled,
    citrus2022: pagerItemDisabledCitron,
});
export var PagerRangeContainer = citrusStyled.span('pagerRangeContainer', {
    legacy: pagerRangeContainer,
    citrus2022: pagerRangeContainerCitron,
});
export var PagerRangeContainerDisabled = citrusStyled.span('pagerRangeContainerDisabled', {
    legacy: pagerRangeContainerDisabled,
    citrus2022: pagerRangeContainerDisabledCitron,
});
export var InvalidPrimaryKeyContainer = citrusStyled.div('invalidPrimaryKeyContainer', {
    legacy: invalidPrimaryKeyContainer,
    citrus2022: invalidPrimaryKeyContainerCitron,
});
export var InvalidPrimaryKeyIconContainer = citrusStyled.div('invalidPrimaryKeyIconContainer', {
    legacy: invalidPrimaryKeyIconContainer,
    citrus2022: invalidPrimaryKeyIconContainerCitron,
});
export var InvalidPrimaryKeyContentWrapper = citrusStyled.div('invalidPrimaryKeyContentWrapper', {
    legacy: invalidPrimaryKeyContentWrapper,
    citrus2022: invalidPrimaryKeyContentWrapperCitron,
});
export var InvalidPrimaryKeyMessage = citrusStyled.div('invalidPrimaryKeyMessage', {
    legacy: invalidPrimaryKeyMessage,
    citrus2022: invalidPrimaryKeyMessageCitron,
});
export var InvalidPrimaryKeyTitle = citrusStyled.div('invalidPrimaryKeyTitle', {
    legacy: invalidPrimaryKeyTitle,
    citrus2022: invalidPrimaryKeyTitleCitron,
});
export var Styled = {
    ActionAreaContainer: ActionAreaContainer,
    ActionAreaHeader: ActionAreaHeader,
    ActionAreaFooter: ActionAreaFooter,
    Container: Container,
    FooterToolbar: FooterToolbar,
    Input: Input,
    InputDisabled: InputDisabled,
    Pager: Pager,
    PagerContainer: PagerContainer,
    PagerControl: PagerControl,
    PagerControlDisabled: PagerControlDisabled,
    PagerItem: PagerItem,
    PagerItemActive: PagerItemActive,
    PagerItemDisabled: PagerItemDisabled,
    PagerList: PagerList,
    PagerLink: PagerLink,
    PagerLinkDisabled: PagerLinkDisabled,
    PagerRangeContainer: PagerRangeContainer,
    PagerRangeContainerDisabled: PagerRangeContainerDisabled,
    RowExpandable: RowExpandable,
    SelectedCountContainer: SelectedCountContainer,
    SelectedCountContainerDisabled: SelectedCountContainerDisabled,
    SortWrapper: SortWrapper,
    SortWrapperAsc: SortWrapperAsc,
    SortWrapperAscDisabled: SortWrapperAscDisabled,
    SortWrapperDesc: SortWrapperDesc,
    SortWrapperDescDisabled: SortWrapperDescDisabled,
    Table: Table,
    Tbody: Tbody,
    Th: Th,
    ThDisabled: ThDisabled,
    ThGroup: ThGroup,
    ThGroups: ThGroups,
    Thead: Thead,
    Td: Td,
    TdToggleExpanded: TdToggleExpanded,
    TdToggleNotExpanded: TdToggleNotExpanded,
    TdToggleDisabled: TdToggleDisabled,
    Tr: Tr,
    TrAlt: TrAlt,
    TrAltDisabled: TrAltDisabled,
    TrAltError: TrAltError,
    TrAltWarning: TrAltWarning,
    TrDisabled: TrDisabled,
    TrError: TrError,
    TrWarning: TrWarning,
    UpperToolbar: UpperToolbar,
    WarningMessage: WarningMessage,
};
